import { Inject, Injectable } from "@angular/core";
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  ILookupResponse,
  FpxModal,
} from "@fpx/core";
import { Observable, map, of } from "rxjs";
import { Router } from "@angular/router";
import { TransferhistoryService } from "../transferhistory-service/transferhistory.service";
import { Transferhistory } from "../transferhistory-service/transferhistory.model";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ResponsiveService } from "src/app/responsive.service";

export class TransferHistoryDetailState extends BaseFpxComponentState {
  showSuggestion: boolean = false;
  popupData: any;
}

@Injectable()
export class TransferHistoryDetailHelper extends BaseFpxFormHelper<TransferHistoryDetailState> {
  constructor(
    private _dialog: MatDialog,
    public responsive: ResponsiveService,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData,
    private transferHistoryDetailService: TransferhistoryService,
    private _httpProvider: HttpProviderService,
    private _router: Router
  ) {
    super(new TransferHistoryDetailState());
  }

  override doPreInit(): void {}

  public override doPostInit(): void {
    this.state.popupData = this.data?.screenData?.data;
    //  this.formGroup.setValue(formGroupData);
  }

  public doDestroy(): void {}

  public override preSubmitInterceptor(payload: Transferhistory): any {
    // WRITE CODE HERE TO HANDLE
    return payload;
  }

  public override postSubmitInterceptor(response: any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        transRef: response.success?.body?.fpxdeposit?.depositRef,
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
  //$START_CUSTOMSCRIPT\n
  //$END_CUSTOMSCRIPT\n
}
